const PERFIOS_TRANSACTION = 'perfios-transaction';

export default PERFIOS_TRANSACTION;
